import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { Controller, useForm } from "react-hook-form";
import Gray_Btn from "../../../../../common/common_btn/gray_btn/Gray_Btn";
import Black_Submit_Btn from "../../../../../common/common_btn/black_submit_btn/Black_Submit_Btn";
import Success_Toster from "../../../../../common/common_modal/success_toster/Success_Toster";
import Refresh_btn from "../../../../../common/common_btn/refresh_btn/Refresh_btn";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { useDispatch, useSelector } from "react-redux";

const Common_Form = ({
  handleClose,
  showError,
  onSubmit,
  defaultValues,
  success,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    setValue,
    formState: { errors },
  } = useForm({ defaultValues });

// console.log("showErrorshowError",showError)
  const dispatch = useDispatch();

  // Set default values if editing
  useEffect(() => {
    reset(defaultValues);
  }, [defaultValues, reset]);

  const [imagePreview, setImagePreview] = useState(null);

  const documentSectionRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <div className="white_container" ref={documentSectionRef}>
        <div className="common_form_div">
          <div className="row">
            {/* Full Name */}
            <div className="col-sm-6">
              <Form.Group className="form_group">
                <Form.Label> Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder=" Name"
                  {...register("name", {
                    required: " Name is required",
                  })}
                />
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
                {showError?.name && (
                  <Form.Text className="text-danger">{showError?.name}</Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
        </div>

        {/* Footer Buttons */}
        <div className="offcanvas_footer_holder">
          {!success ? (
            <div className="btns_holder">
              <Gray_Btn btnText="Cancel" onClick={handleClose} />
              <Black_Submit_Btn btnText="Submit" type="submit" />
              {/* <Refresh_btn /> */}
            </div>
          ) : (
            <Success_Toster successText="Data saved successfully!" />
          )}
        </div>
      </div>
    </Form>
  );
};

export default Common_Form;
